export default __webpack_public_path__ + "static/media/logo.ab51bd34.svg";